import * as VitaloJak1Api from '../../../misc/api/DeviceLinkApi/VitaloJak1';
import { Device } from '../../../misc/api/DeviceLinkApi/Devices';
import { SubjectTypes } from '../../../misc/api/apiTypes';
import { TrainingCardUsedForInStudyErrorMessage, AlreadyConfiguredMessage, TrainingCardWarningMessage, sessionCreatedDeviceNotConfiguredMessage } from '../../../misc/api/DeviceLinkApi/VitaloJak1Messages';
import { WebPortalClient, StudyScheduleSession } from "webportalclient";

declare const rootUrl: string;

export const VitaloJak1CheckExistingData = async (client: WebPortalClient, device: Device, subjectType: SubjectTypes, subjectId: string, selectedSessions: StudyScheduleSession[], raiseConfigurationError: (message: string, isWarning: boolean, deviceSerial?: string, cardSerial?: string) => void) => {
    const isTrainingCardResult = await VitaloJak1Api.ApiGetIsTrainingCard(device.id);
    const configuration = await VitaloJak1Api.ApiGetConfiguration(device.id);
    const getCoughSessions = await client.getCoughSessions(undefined, `visit/subjectId eq ${subjectId} and name eq '${selectedSessions[0].label}'`, undefined, "visit");
    
    const checkIfSessionExists = getCoughSessions.value[0];

    if (subjectType === SubjectTypes.InStudy && isTrainingCardResult.isSuccess) {
        raiseConfigurationError(TrainingCardUsedForInStudyErrorMessage, false);
        return false;
    }

    if (subjectType !== SubjectTypes.InStudy && (configuration !== null && configuration.subjectState === 0)) {
        raiseConfigurationError(AlreadyConfiguredMessage, false);
        return false;
    }

    if (checkIfSessionExists) {
        const getSessions = await client.getSessions(undefined, "Id eq " + getCoughSessions.value[0].id);
        raiseConfigurationError(sessionCreatedDeviceNotConfiguredMessage, true, getSessions.value[0].serialNumber, getCoughSessions.value[0].mediaSerialNumber);
        return true;
    }

    if (subjectType !== SubjectTypes.InStudy) {
        raiseConfigurationError(TrainingCardWarningMessage, true);
    }

    if (configuration !== null && subjectType === SubjectTypes.InStudy) {
        raiseConfigurationError(AlreadyConfiguredMessage, false);
        return false;
    }

    return true;
}
